import { useTranslate } from "helpers";
import { VehicleSpecificationProps } from "../types";

const VehicleTypeSection: React.FC<VehicleSpecificationProps> = ({ fleetVehicleDetail }) => {
    const { t } = useTranslate();

    return (
        <div className="border-b border-slate-200 pt-4 px-4">
            <div className="text-sm font-bold text-slate-600 mb-3">
                {t("admin.fleet.vehicle.detail.info.type")}
            </div>
            <div className="grid grid-cols-4 gap-3 mb-4">
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.vehiclemanufacturer.name")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {fleetVehicleDetail.vehicleManufacturer?.name}
                    </div>
                </div>
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.vehiclemodel.name")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {fleetVehicleDetail.vehicleModel?.name}
                    </div>
                </div>
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.vehicletype.name")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {fleetVehicleDetail.vehicleType?.name}
                    </div>
                </div>
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.vinnumber")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {fleetVehicleDetail.vinNumber}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleTypeSection;
